<template>
    <b-modal v-if="!loading" id="inspection_form" ref="inspection_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right-inspection modal-dialog-scrollable">
        <template v-slot:modal-title>
            {{ !edit ? 'Add New Inspection' : 'Edit Inspection' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row v-if="fetchedInspection">
                <b-colxx v-if="fetchedInspection.initial" md="12">
                    <b-alert show variant="info">
                        Creating an initial inspection for current quarter.
                    </b-alert>
                </b-colxx>

                <b-colxx v-else md="12">
                    <b-alert show variant="warning">Follow-up inspection. <br>
                        Date: {{ fetchedInspection.inspected_date }} | Inspector:
                        {{ fetchedInspection.inspector }}
                    </b-alert>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facility" class="has-float-label">
                        <template v-slot:label>
                            <span>Facility <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors" :disabled="edit"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="4">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus"
                            mode="single"
                            v-model="datepicker.date"
                            @input="updateCapDueDate"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!('date' in errors)"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="CAP Due" class="has-float-label">
                        <template v-slot:label>
                            <span>CAP Due <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right"
                            popover-visibility="focus"
                            mode="single"
                            v-model="datepicker.cap_due"
                            @input="'cap_due' in errors ? (delete errors.cap_due) : ''"
                            :input-props="{ class:'form-control' + ('cap_due' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!('cap_due' in errors)"
                                                 v-text="'cap_due' in errors ? errors.cap_due[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="4">
                    <b-form-group label="Inspected Areas" class="has-float-label">
                        <template v-slot:label>
                            <span>Inspected Areas <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.inspected_areas"
                                      @input="'inspected_areas' in errors ? (delete errors.inspected_areas) : ''"
                                      :class="{'border-danger': 'inspected_areas' in errors}"
                                      autocomplete="off" placeholder="Total Areas"/>

                        <b-form-invalid-feedback :state="!('inspected_areas' in errors)"
                                                 v-text="'inspected_areas' in errors ? errors.inspected_areas[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx xxs="12" class="my-2">
                    <h4 class="text-success">Add deficiency details</h4>
                </b-colxx>
            </b-row>

            <div class="mb-2">
                <b-row class="mt-1">
                    <b-colxx md="3">
                        <b-form-group label="Unit/Content">
                            <template v-slot:label>
                                <span>Unit/Content <sup><code>*</code></sup></span>
                            </template>

                            <b-input-group>
                                <b-input-group-prepend title="Other content?" is-text>
                                    <input type="checkbox" :checked="contentForm.other_content === 'yes'"
                                           @input="checkOtherContent"/>
                                </b-input-group-prepend>

                                <template v-if="selected.unit">
                                    <b-form-select v-model="selected.unit.unit_id"
                                                   v-if="contentForm.other_content === ''"
                                                   :class="{'border-danger': 'unit_id' in contentErrors}"
                                                   @change="updateUnit" plain>
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>Units</b-form-select-option>
                                        </template>

                                        <b-form-select-option v-for="(unit, index) in units" :key="index" :value="unit">
                                            {{ unit.label }}
                                        </b-form-select-option>
                                    </b-form-select>

                                    <b-form-input v-else type="text" v-model="contentForm.content" :class="{'border-danger': 'content' in contentErrors}"
                                                  @input="clearUnitOrContent"
                                                  placeholder="Other Content"/>
                                </template>
                            </b-input-group>

                            <b-form-invalid-feedback :state="!contentForm.unit_id in contentErrors"
                                                     v-text="'unit_id' in contentErrors ? contentErrors.unit_id[0] : ''"/>

                            <b-form-invalid-feedback :state="!contentForm.content in contentErrors"
                                                     v-text="'content' in contentErrors ? contentErrors.content[0] : ''"/>
                        </b-form-group>
                    </b-colxx>

                    <b-colxx md="3">
                        <b-form-group label="Category">
                            <template v-slot:label>
                                <span>Category <sup><code>*</code></sup></span>
                            </template>

                            <template v-if="selected.category">
                                <b-form-select v-model="selected.category.category_id" @change="updateCategory"
                                               :class="{'border-danger': 'category_id' in contentErrors}" plain>
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Categories</b-form-select-option>
                                    </template>

                                    <b-form-select-option v-for="(category, index) in categories" :key="index"
                                                          :value="category">
                                        {{ category.label }}
                                    </b-form-select-option>
                                </b-form-select>
                            </template>

                            <b-form-invalid-feedback :state="!contentForm.category_id in contentErrors"
                                                     v-text="'category_id' in contentErrors ? contentErrors.category_id[0] : ''"/>
                        </b-form-group>
                    </b-colxx>

                    <b-colxx md="3">
                        <b-form-group label="Detail">
                            <template v-slot:label>
                                <span>Detail <sup><code>*</code></sup></span>
                            </template>

                            <template>
                                <b-form-select v-model="selected.detail" @change="updateDetail" :class="{'border-danger': 'detail_id' in contentErrors}" plain>
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>Details</b-form-select-option>
                                    </template>

                                    <b-form-select-option v-for="(detail, index) in details" :key="index"
                                                          :value="detail">
                                        {{ detail.label }}
                                    </b-form-select-option>
                                </b-form-select>
                            </template>

                            <b-form-invalid-feedback :state="!contentForm.detail_id in contentErrors"
                                                     v-text="'detail_id' in contentErrors ? contentErrors.detail_id[0] : ''"/>
                        </b-form-group>
                    </b-colxx>

                    <b-colxx md="3">
                        <b-form-group label="Remarks">
                            <b-input-group>
                                <b-form-input type="text" v-model="contentForm.remarks" placeholder="Remarks"/>
                                <b-input-group-append>
                                    <b-button @click.prevent="addDeficiency" class="px-3" style="font-size: 26px"
                                              size="xs" variant="outline-primary">
                                        <b>+</b>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-colxx>
                </b-row>
            </div>

            <b-row>
                <b-colxx xxs="12" class="my-2">
                    <h4>Deficiencies List</h4>
                </b-colxx>
            </b-row>

            <div class="mb-4">
                <div v-if="form.contents.length <= 0" class="">
                    <p>There are no deficiencies to show.</p>
                </div>

                <vue-perfect-scrollbar v-else class="scroll" style="height: 350px;"
                                       :settings="{ suppressScrollX: true, wheelPropagation: true }">
                    <b-table :fields="deficienciesTable.fields" :items="form.contents">
                        <template v-slot:cell(serial)="data">
                            <span v-text="form.contents.indexOf(data.item) + 1"/>
                        </template>

                        <template v-slot:cell(content)="data">
                            <span v-if="data.item.other_content === ''" v-text="data.item.unit_label"/>
                            <span v-else-if="data.item.other_content === 'yes'" v-text="data.item.content"/>
                        </template>

                        <template v-slot:cell(category)="data">
                            <span v-text="data.item.category_label"/>
                        </template>

                        <template v-slot:cell(detail)="data">
                            <span v-text="data.item.detail_label"/>
                        </template>

                        <template v-slot:cell(concern)="data">
                            <span v-text="data.item.concern_label"/>
                        </template>

                        <template v-slot:cell(remarks)="data">
                            <span v-text="data.item.remarks"/>
                        </template>

                        <template v-slot:cell(action)="data">
                            <a class="text-danger" style="cursor: pointer"
                               @click="removeContent(form.contents.indexOf(data.item))">
                                <span>Delete</span>
                            </a>
                        </template>
                    </b-table>
                </vue-perfect-scrollbar>
            </div>

            <b-row class="mb-3">
                <b-colxx md="12">
                    <vue-dropzone ref="fileDropZone" id="dropzone"
                                  @vdropzone-error="attachmentError"
                                  :destroy-dropzone="false" :options="dropzoneOptions"/>
                </b-colxx>
            </b-row>

            <b-row v-if="edit">
                <b-colxx md="12">
                    <FilesList v-if="form.attachments" :edit="true" :files="form.attachments.data"
                               @delete="deleteFile"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea rows="6" v-model="form.notes" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx xxs="3" class="mb-4">
                    <toggle-button v-model="form.status" @input="'status' in errors ? (delete errors.status) : ''"
                                   :labels="{checked: 'COMPLETE', unchecked: 'INCOMPLETE'}" :height="30" :width="105"
                                   :color="{checked: '#28A745', unchecked: '#B69329'}"/>
                </b-colxx>

                <b-colxx xxs="9" class="mb-2">
                    <h6>
                        <b-badge :variant="'outline-' + (form.status ? 'success' : 'warning')">
                            The Inspection status will be {{ form.status ? 'COMPLETED' : 'INCOMPLETE' }} after
                            submission!
                        </b-badge>
                    </h6>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('inspection_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit && form.type === 'initial'" variant="primary" :click="submitInspection">
                Submit
            </state-button>

            <state-button v-if="!edit && form.type === 'follow-up'" variant="primary" :click="submitFollowupInspection">
                Submit
            </state-button>

            <state-button v-if="edit" variant="primary" :click="updateInspection">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";
import {mapGetters} from "vuex";
import moment from "moment";
import VueDropzone from 'vue2-dropzone';
import FilesList from "../../../../../components/Listing/FilesList";

export default {
    name: "InspectionFormModal",

    components: {
        StateButton,
        VueDropzone,
        FilesList,
    },

    props: [
        'edit'
    ],

    data() {
        return {
            loading: true,
            fetchedInspection: null,
            contentForm: {
                unit_id: "",
                unit_label: "",
                content: "",
                other_content: "",
                category_id: "",
                category_label: "",
                detail_id: "",
                detail_label: "",
                concern_id: "",
                concern_label: "",
                remarks: ""
            },
            selected: {
                facility: [],
                unit: [],
                detail: [],
                category: [],
            },
            deleted_contents: [],
            deleted_attachments: [],
            datepicker: {
                date: null,
                cap_due: null,
            },
            validationError: null,
            deficienciesTable: {
                fields: [
                    {key: 'serial', label: '#'},
                    {key: 'content', label: 'UNIT/CONTENT'},
                    {key: 'category', label: 'CATEGORY'},
                    {key: 'detail', label: 'DETAIL'},
                    {key: 'concern', label: 'CONCERN'},
                    {key: 'remarks', label: 'REMARKS'},
                    {key: 'action', label: 'ACTION'},
                ]
            },
            contentErrors: {},
            dropzoneOptions: {
                url: 'url',
                thumbnailHeight: 160,
                acceptedFiles: '.jpg,.jpeg,.png,.pdf',
                maxFilesize: 10,
                previewTemplate: this.dropzoneTemplate(),
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.accessToken
                },
                dictDefaultMessage: 'Drop or Click here to upload files.<br>Max file size 10MB.<br>Accepted file types: JPG, JPEG, PNG, PDF.',
                autoProcessQueue: false
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getInspectionForm',
            errors: 'getInspectionErrors',
            facilities: 'getSelectFacilities',
            units: 'getSelectFacilityUnits',
            categories: 'getSelectInspectionCategories',
            details: 'getSelectInspectionCategoryDetails',
        }),

        base_url() {
            if (this.edit) {
                return '/api/hms/inspections/' + this.form.id + '/attachments';
            }
        },
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.facility = this.form.select_facility;
                this.$store.dispatch('fetchSelectFacilityUnits', this.form.facility_id);

                this.datepicker.date = moment(this.form.date).toDate();
                this.datepicker.cap_due = moment(this.form.cap_due).toDate();
            }
        },

        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
        'datepicker.cap_due'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.cap_due = null;
            this.form.cap_due = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        deleteFile(file) {
            this.deleted_attachments.unshift(file);
            this.form.attachments.data.splice(file.index, 1);
        },

        async getFormData() {
            await this.$store.dispatch('fetchSelectFacilities');
            await this.$store.dispatch('fetchSelectInspectionCategories');

            return this.loading = false;
        },

        fetchInspection(facility_id) {
            axios.get('/api/hms/inspections/fetch/' + facility_id)
                .then(response => {
                    this.fetchedInspection = response.data;

                    if (this.fetchedInspection.initial) {
                        this.form.type = 'initial';
                    } else {
                        this.$store.dispatch('fetchFollowupForm', response.data)
                            .then(response => {
                                this.datepicker.date = moment(this.form.date).toDate();
                                this.datepicker.cap_due = moment(this.form.cap_due).toDate();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    }
                })
                .catch(error => {
                    if (error.response.data.error) {
                        this.validationError = error.response.data.error;
                    }

                    console.log(error);
                });
        },

        updateFacility(field) {
            this.form.contents = [];
            if (field) {
                this.form.facility_id = field.facility_id;
                this.fetchInspection(this.form.facility_id);
                this.$store.dispatch('fetchSelectFacilityUnits', field.facility_id);
            } else {
                this.form.facility_id = '';
            }

            this.validationError = null;

            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        updateCapDueDate(field) {
            this.datepicker.cap_due = moment(field).add(21, 'days').toDate();
            this.form.cap_due = moment(field).add(21, 'days').format('YYYY-MM-DD');

            this.validationError = null;

            'date' in this.errors ? (delete this.errors.date) : '';
        },

        getContentErrors() {
            let errors = {};
            if (this.contentForm.other_content === 'yes') {
                if (!this.contentForm.content) errors['content'] = ["The content field is required"]
            } else if (this.contentForm.other_content === '') {
                if (!this.contentForm.unit_id) errors['unit_id'] = ["The unit id field is required"]
            }

            if (!this.contentForm.category_id) errors['category_id'] = ["The category id field is required"]
            if (!this.contentForm.detail_id) errors['detail_id'] = ["The detail id field is required"]
            if (!this.contentForm.concern_id) errors['concern_id'] = ["The concern id field is required"]
            if (Object.keys(errors).length !== 0) {
                return this.contentErrors = errors;
            }
        },

        checkOtherContent() {
            if (this.contentForm.other_content === '') {
                this.contentForm.other_content = 'yes';
                this.selected.unit = {
                    label: "Units",
                    unit_id: null,
                };
            } else {
                this.contentForm.other_content = '';
            }

            this.contentForm.unit_id = '';
            this.contentForm.content = '';
        },

        clearUnitOrContent(){
            if ('content' in this.contentErrors) {
                delete this.contentErrors['content'];
            } else if(('unit_id' in this.contentErrors)) {
                delete this.contentErrors['unit_id'];
            }
        },

        updateUnit(field) {
            if (field) {
                this.contentForm.unit_id = field.unit_id;
                this.contentForm.unit_label = field.label;
            } else {
                this.contentForm.unit_id = '';
            }

            'unit_id' in this.contentErrors ? delete this.contentErrors.unit_id : '';
            'content' in this.contentErrors ? delete this.contentErrors.content : '';
        },

        updateCategory(field) {
            if (field) {
                this.contentForm.category_id = field.category_id;
                this.contentForm.category_label = field.label;

                this.selected.detail = {
                    label: "Details",
                    detail_id: null,
                };

                this.$store.dispatch('fetchSelectInspectionCategoryDetails', field.category_id);

                'category_id' in this.contentErrors ? delete this.contentErrors.category_id : '';
            }
        },

        updateDetail(field) {
            if (field) {
                this.contentForm.detail_id = field.detail_id;
                this.contentForm.detail_label = field.label;
                this.fetchConcern(field);
            } else {
                this.contentForm.detail_id = '';
            }

            'detail_id' in this.contentErrors ? delete this.contentErrors.detail_id : '';
        },

        fetchConcern(field) {
            axios.get('/api/hms/inspections/fetch/details/' + field.detail_id + '/concern')
                .then(response => {
                    this.contentForm.concern_id = response.data.concern_id;
                    this.contentForm.concern_label = response.data.label;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        addDeficiency() {
            if (this.getContentErrors()) {
                return;
            }

            this.form.contents.unshift({
                // for db
                unit_id: this.contentForm.unit_id,
                content: this.contentForm.content,
                concern_id: this.contentForm.concern_id,
                detail_id: this.contentForm.detail_id,
                remarks: this.contentForm.remarks,
                category_id: this.contentForm.category_id,
                // for frontend table only
                unit_label: this.contentForm.unit_label,
                category_label: this.contentForm.category_label,
                detail_label: this.contentForm.detail_label,
                concern_label: this.contentForm.concern_label,
                other_content: this.contentForm.other_content,
            });

            this.contentForm = {
                unit_id: "",
                unit_label: "",
                content: "",
                other_content: "",
                category_id: "",
                category_label: "",
                detail_id: "",
                detail_label: "",
                concern_id: "",
                concern_label: "",
                remarks: ""
            };

            this.selected.unit = [];
            this.selected.category = [];
            this.selected.detail = [];

            this.contentErrors = {};
        },

        removeContent(index) {
            if (this.edit) {
                this.deleted_contents.unshift(this.form.contents[index]);
            }
            this.form.contents.splice(index, 1);
        },

        resetForm() {
            this.$emit('closed');
            this.$store.commit('setInspectionForm');

            this.selected = {
                facility: [],
                unit: [],
                detail: [],
                category: [],
            };

            this.datepicker = {
                date: null,
                cap_due: null,
            };

            this.deleted_contents = [];
            this.deleted_attachments = [];

            this.validationError = null;

            this.fetchedInspection = null;
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        uploadFiles(inspection) {
            let url = '/api/hms/inspections/' + inspection.inspection_id + '/attachments';

            this.$refs.fileDropZone.setOption('url', url);

            this.$refs.fileDropZone.processQueue(inspection);
        },

        attachmentError(file, message, xhr) {
            this.$refs.fileDropZone.removeFile(file);
            this.$notify('error filled', 'Error!', file.name + " could not be added!", {
                duration: 6000,
                permanent: false
            });
        },

        dropzoneTemplate() {
            return `<div class="dz-preview dz-file-preview mb-3">
                  <div class="d-flex flex-row "> <div class="p-0 w-30 position-relative">
                      <div class="dz-error-mark"><span><i></i>  </span></div>
                      <div class="dz-success-mark"><span><i></i></span></div>
                      <div class="preview-container">
                        <img data-dz-thumbnail class="img-thumbnail border-0" />
                        <i class="simple-icon-doc preview-icon"></i>
                      </div>
                  </div>
                  <div class="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                    <div> <span data-dz-name /> </div>
                    <div class="text-primary text-extra-small" data-dz-size /> </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                  </div>
                  <a href="#" class="remove" data-dz-remove> <i class="glyph-icon simple-icon-trash"></i> </a>
                </div>`
        },

        submitInspection() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitInspection', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new Inspection!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('inspection_form');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        submitFollowupInspection() {
            return new Promise((success, fail) => {
                this.$store.dispatch('followupInspection', this.form)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new follow-up inspection!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('inspection_form');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateInspection() {
            let payload = {
                ...this.form,
                type: this.form.following ? 'follow-up' : 'initial',
                deleted_contents: this.deleted_contents,
                deleted_attachments: this.deleted_attachments,
            };

            return new Promise((success, fail) => {
                this.$store.dispatch('updateInspection', payload)
                    .then(response => {
                        this.uploadFiles(response.data);
                    })
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the inspection!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('inspection_form');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
